import { Outlet } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { PWAEnforcer } from '@/modules/pwa/components/PWAEnforcer';

export function RootLayout() {
  return (
    <PWAEnforcer>
      <Outlet />
      <Toaster position="top-right" />
    </PWAEnforcer>
  );
}
